module.exports = __webpack_public_path__ + "img/4.b50bdc68.png";